import styled from "styled-components"
import * as A from "../ApprovedPanel/styled"

export const Eyebrow = styled.span`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.green.main};
`

// A moldura (borda suave) vem do bloco da página; aqui só o layout interno.
export const Card = styled(A.Wrapper)`
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    gap: 16px;
  }
`

export const HeroIcon = styled.div`
  display: grid;
  place-items: center;
  width: 84px;
  height: 84px;
  border-radius: 50%;
  background-color: rgba(55, 133, 88, 0.12);

  svg {
    width: 46px;
    height: 46px;
    color: ${({ theme }) => theme.colors.green.main};
  }

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    width: 64px;
    height: 64px;

    svg {
      width: 34px;
      height: 34px;
    }
  }
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;

  h1 {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    line-height: 1.2;
    color: #1f2437;
  }

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    gap: 6px;

    h1 {
      font-size: 22px;
    }
  }
`

export const OrderCard = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  border-radius: 16px;
  background-color: #f3f4f6;

  & > div.icon {
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    width: 52px;
    height: 52px;
    border-radius: 12px;
    background-color: rgba(0, 97, 230, 0.1);

    svg {
      width: 26px;
      height: 26px;
      color: ${({ theme }) => theme.colors.blue.main};
    }
  }

  & > div.info {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;

    strong {
      min-width: 0;
      font-size: 17px;
      font-weight: 600;
      color: #111827;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    span.dot {
      flex: 0 0 auto;
      font-size: 10px;
      color: #6b7280;
    }

    span.qnt {
      flex: 0 0 auto;
      font-size: 17px;
      color: #6b7280;
    }
  }

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    gap: 12px;
    padding: 10px 12px;
    border-radius: 12px;

    & > div.icon {
      width: 40px;
      height: 40px;

      svg {
        width: 20px;
        height: 20px;
      }
    }

    & > div.info {
      flex-wrap: wrap;
      gap: 0 8px;

      strong {
        flex: 1 1 100%;
        font-size: 15px;
        white-space: normal;
        overflow: visible;
      }

      span.dot {
        display: none;
      }

      span.qnt {
        font-size: 13px;
      }
    }
  }
`

export const ActionsBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
`

export const ChooseLabel = styled.p`
  margin: 0 0 2px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #374151;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    font-size: 14px;
  }
`

/* Envio automático não entregue: aviso discreto no lugar do "Escolha como". */
export const DeliveryWarning = styled.p`
  margin: 0 0 2px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.45;
  color: #92400e;

  @media (max-width: ${({ theme }) => theme.bp.medium}px) {
    font-size: 14px;
  }
`

const actionBase = `
  width: 100%;
  min-height: 56px;
  padding: 0 18px;
  border-radius: 14px;
  outline: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-family: inherit;
  font-size: 19px;
  font-weight: 600;
  transition: box-shadow 0.2s, background-color 0.2s;

  svg {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
  }

  @media (max-width: 920px) {
    min-height: 48px;
    gap: 10px;
    font-size: 15px;
    border-radius: 12px;

    svg {
      width: 22px;
      height: 22px;
    }
  }
`

export const MainAction = styled.button`
  ${actionBase}
  border: none;
  color: #fff;
  background-color: ${({ theme }) => theme.colors.green.main};

  svg path {
    fill: #fff;
  }

  /* Ícones do lucide são só traço: o fill branco do ícone do WhatsApp os apagaria. */
  svg.lucide path {
    fill: none;
  }

  &:hover,
  &:active {
    box-shadow: 0 6px 16px rgba(55, 133, 88, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: default;
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.green.main};
    outline-offset: 2px;
  }
`

export const SecondaryAction = styled.button`
  ${actionBase}
  color: #1f2437;
  background-color: #f9fafb;
  border: 1px solid #d1d5db;

  &:hover,
  &:active {
    background-color: #f3f4f6;
  }

  &:focus-visible {
    outline: 2px solid #6b7280;
    outline-offset: 2px;
  }
`

export const Hint = styled.p`
  margin: 0;
  text-align: center;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
`

export const Loading = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #6b7280;
  font-size: 14px;
`

/* Envio pelo WhatsApp confirmado: cartão em destaque com o número. */
export const DeliveredCard = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px;
  border-radius: 16px;
  background: #f0fdf4;
  border: 1.5px solid rgba(37, 211, 102, 0.4);
  text-align: left;
`

export const DeliveredIcon = styled.div`
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  box-shadow: 0 4px 12px rgba(18, 140, 126, 0.25);

  svg {
    width: 24px;
    height: 24px;
  }

  svg path {
    fill: #fff;
  }
`

export const DeliveredBody = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DeliveredTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
`

export const PhoneChip = styled.span`
  display: flex;
  width: fit-content;
  margin-top: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid rgba(18, 140, 126, 0.25);
  color: #0f172a;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.02em;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`

export const DeliveredNote = styled.p`
  margin: 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.45;
`
